var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Dropdown } from 'semantic-ui-react';
import styled from 'styled-components';
var StyledDropdownHeader = styled(Dropdown.Header)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
Object.assign(StyledDropdownHeader, {
    displayName: 'DropdownHeader',
});
export default StyledDropdownHeader;
var templateObject_1;
//# sourceMappingURL=header.js.map